(function () {
  'use strict';
  angular.module('eclipseApp.support').controller('supportCtrl', ['$scope', function ($scope) {

  }]);
})();
